import classnames from 'classnames';

const {
	InnerBlocks,
} = wp.blockEditor;

const { Fragment } = wp.element;

import BackgroundDiv from '../../components/reusable/background/BackgroundDiv452';
import { getPositionClassName } from '../utils';
import { defaultBackground } from '../../components/reusable/background/attributes';

const v500 = {
	attributes: {
		gsBlockId: {
			type: 'string',
			default: '',
		},
		background: {
			type: 'object',
			default: defaultBackground,
		},
		isEditable: {
			type: 'boolean',
			default: true,
		},
		mediaUrl: {
			type: 'string',
			source: 'attribute',
			selector: '.slide-bg img, .slide-bg video',
			attribute: 'src',
		},
		mediaAlt: {
			type: 'string',
			source: 'attribute',
			selector: '.slide-bg img',
			attribute: 'alt',
			default: '',
		},
		mediaType: {
			type: 'string',
		},
		mediaId: {
			type: 'number',
		},
		overlayColor: {
			type: 'string',
			default: '',
		},
		dimRatio: {
			type: 'number',
			default: 0.5,
		},
		rgbaBackground: {
			type: 'string',
			default: '',
		},
		initialized: {
			type: 'boolean',
			default: false,
		},
		linkUrl: {
			type: 'string',
			default: '',
		},
		verticalAlign: {
			type: 'string',
			default: 'center',
		},
		contentPosition: {
			type: 'string',
			default: 'center',
		},
		autoCaption: {
			type: 'string',
			default: 'none',
		},
		minWidth: {
			type: 'string',
			default: '67%',
		},
		mixBlendMode: {
			type: 'string',
			default: 'none',
		},
	},
	save: function() {
		return ( <div className="yeah"></div> );
	}
}

const v452 = {
	attributes: {
		gsBlockId: {
			type: 'string',
		},
		background: {
			type: 'object',
			default: defaultBackground,
		},
		isEditable: {
			type: 'boolean',
			default: true,
		},
		mediaUrl: {
			type: 'string',
			source: 'attribute',
			selector: '.slide-bg img, .slide-bg video',
			attribute: 'src',
		},
		mediaAlt: {
			type: 'string',
			source: 'attribute',
			selector: '.slide-bg img',
			attribute: 'alt',
			default: '',
		},
		mediaType: {
			type: 'string',
		},
		mediaId: {
			type: 'number',
		},
		overlayColor: {
			type: 'string',
			default: '',
		},
		dimRatio: {
			type: 'number',
			default: 0.5,
		},
		rgbaBackground: {
			type: 'string',
			default: '',
		},
		initialized: {
			type: 'boolean',
			default: false,
		},
		linkUrl: {
			type: 'string',
			default: '',
		},
		verticalAlign: {
			type: 'string',
			default: 'center',
		},
		contentPosition: {
			type: 'string',
			default: 'center',
		},
		autoCaption: {
			type: 'string',
			default: 'none',
		},
	},
	save: function( { attributes } ) {
		const {
			linkUrl,
			verticalAlign,
			background,
			contentPosition,
			gsBlockId,
		} = attributes;

		const linkTo = typeof linkUrl !== 'undefined' && linkUrl && linkUrl !== '' ?
			encodeURI( linkUrl ) : false;

		const linkifyButton = ( jsxElements ) => {
			return (
				<Fragment>
					{ linkTo &&
						<a className="slide-link" href={ linkTo } > { jsxElements }</a>
					}
				</Fragment>
			);
		};

		const classes = classnames(
			'wp-block-eedee-block-gutenslide', {
				[ `vertical-align-${ verticalAlign }` ]: verticalAlign,
			},
			getPositionClassName( contentPosition ),
		);

		return (
			<div className={ classes }>
				<div id={ `gutenslide-${ gsBlockId }` }>
					<BackgroundDiv background={ background } />
					<div className="slide-content">
						<InnerBlocks.Content />
					</div>
					{ linkifyButton( ) }
				</div>
			</div>
		);
	},
};

const deprecated = [ v452 ];
export default deprecated;
